// extracted by mini-css-extract-plugin
export default {"Pagination":"Pagination_Pagination__G4AB9"};